var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGooglePlay = function SvgGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.362.313a1.56 1.56 0 0 0-.36 1.09V18.6c-.021.395.107.785.36 1.09l.058.059 9.63-9.636v-.228L1.42.254l-.058.06Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.26 13.324-3.211-3.212v-.228l3.212-3.206.072.04 3.806 2.16c1.09.614 1.09 1.626 0 2.246l-3.806 2.16-.072.04Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.333 13.285-3.264-3.264-9.708 9.668a1.306 1.306 0 0 0 1.6.046l11.352-6.45M14.333 6.718 2.96.26a1.26 1.26 0 0 0-1.6.052l9.688 9.688 3.284-3.283Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m14.261 13.213-11.3 6.41a1.305 1.305 0 0 1-1.56 0l-.06.06.06.058a1.305 1.305 0 0 0 1.56 0l11.352-6.45-.052-.078Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M1.362 19.585a1.587 1.587 0 0 1-.36-1.097v.11c-.021.396.107.786.36 1.091l.058-.059-.058-.045ZM18.14 11.007l-3.878 2.206.072.072 3.806-2.187a1.378 1.378 0 0 0 .816-1.123 1.442 1.442 0 0 1-.816 1.032Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m2.96.379 15.179 8.61a1.436 1.436 0 0 1 .816 1.012 1.364 1.364 0 0 0-.816-1.123L2.96.261C1.89-.353 1.002.157 1.002 1.404v.11C1.002.275 1.89-.241 2.96.38Z",
    fill: "#fff"
  })));
};
export default SvgGooglePlay;